import React from 'react';
import { Tabs } from '@fikasio/react-ui-components';
import { useTranslation } from 'react-i18next';
import { Template } from 'services/templates/types';
import TemplateInformationsForm from './TemplateInformationsForm';
import TemplateFieldsTable from './TemplateFieldsTable';

export interface TemplateViewProps {
  defaultTab?: string,
  template: Template,
}

const TemplateView = ({
  defaultTab,
  template,
}: TemplateViewProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <Tabs
        className="mb-3"
        defaultValue={defaultTab || 'INFOS'}
        options={[
          {
            content: (
              <TemplateInformationsForm
                template={template}
              />
            ),
            label: t('informations'),
            value: 'INFOS',
          },
          {
            content: (
              <TemplateFieldsTable
                template={template}
              />
            ),
            label: t('fields'),
            value: 'FIELDS',
          },
        ]}
      />
    </div>
  );
};

export default TemplateView;
